import React from "react";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import { BnbLabel } from "../../../utils/labels";
import { useBnbSelector } from "../../../redux/store";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/FinanceList";
import { removeSpaces } from "../../../../../../common-deprecated/utils";

const FinanceQuotes = (): JSX.Element | null => {
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const financeQuoteTable = useBnbSelector((state) => state.finance.info.disclaimer?.table);

    if (!financeQuoteTable || !financeQuoteTable.length || !bnbSettings.showBasketQuoteInfo) return null;

    return (
        <Styles.Wrapper>
            <Styles.Header>
                <BnbLabel label="quotes" />
            </Styles.Header>
            <Styles.Content>
                {financeQuoteTable.map((row) =>
                    row ? (
                        <React.Fragment key={removeSpaces(row.name)}>
                            <Styles.DescriptionTerm>
                                <span>{row.name}</span>
                                {row.tooltip && <Popover showOnClick content={row.tooltip} />}
                            </Styles.DescriptionTerm>
                            <Styles.DescriptionDetail>
                                <span dangerouslySetInnerHTML={{ __html: row.value }} />
                            </Styles.DescriptionDetail>
                        </React.Fragment>
                    ) : null,
                )}
            </Styles.Content>
        </Styles.Wrapper>
    );
};

export default FinanceQuotes;
